import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  CanLoad,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Route,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service.ts';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthenticationWithUserGuard implements CanActivate, CanLoad {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    if (this.authenticationService.isAuthenticated() && this.authenticationService.userInfo) {
      return true;
    }
    return this.authenticationService.getUserInfo().pipe(
      map(() => {
        if (this.authenticationService.isAuthenticated()) {
          return true;
        }
        this.authenticationService.logout();
        this.router.navigate(['/', { outlets: { modal: 'login' } }], {
          queryParams: { redirectTo: state.url },
          replaceUrl: true,
          queryParamsHandling: 'merge',
        });
        return false;
      })
    );
  }

  canLoad(route: Route): boolean | Observable<boolean> {
    if (this.authenticationService.isAuthenticated() && this.authenticationService.userInfo) {
      return true;
    }
    return this.authenticationService.getUserInfo().pipe(
      map(() => {
        if (this.authenticationService.isAuthenticated()) {
          return true;
        }
        this.authenticationService.logout();
        this.router.navigate(['/', { outlets: { modal: 'login' } }], {
          queryParams: { redirectTo: route.path },
          replaceUrl: true,
          queryParamsHandling: 'merge',
        });
        return false;
      })
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/authentication/authentication-with-user.guard.ts